import React from 'react';
import { useAuth } from '../context/AuthContext';

// Usage: <RequirePermission perm="billing_access" cap="can_handle_payments">...</RequirePermission>
export default function RequirePermission({ perm, cap, children, fallback = null }) {
  const { hasPermission, hasCapability } = useAuth();
  const allowed = (perm ? hasPermission(perm) : true) && (cap ? hasCapability(cap) : true);
  if (!allowed) return fallback;
  return <>{children}</>;
}
